(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('scanStatsParser', function () {
        function parseStat(condition, obj) {
            // assuming we have only 'or' conditions
            var re = /(\w+)\s*=\s*'(\w+)'/g;
            // searching for strings like scan_result_a='Infected' and saving left part and part in quotes
            var match;
            while ((match = re.exec(condition)) !== null) {
                if (match && match.length === 3 && obj[match[1]] == match[2]) {
                    return 1;
                }
            }
            return 0;
        }
        return function (data, statDef) {
            var stat = {
                total_match: parseStat(statDef.success_match, data),
                total_unmatch: parseStat(statDef.success_unmatch, data),
                total_error: parseStat(statDef.error, data),
                total_not_scaned: parseStat(statDef.not_scaned, data)
            };
            stat.total = stat.total_match + stat.total_unmatch + stat.total_error + stat.total_not_scaned;
            return stat;
        };
    });
}());